import { render } from "./LoaderComponent.vue?vue&type=template&id=77a87872&scoped=true"
const script = {}

import "./LoaderComponent.vue?vue&type=style&index=0&id=77a87872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a87872"]])

export default __exports__